import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromContract from './contract.reducer';

export interface ContractState {
  details: fromContract.ContractDetailsState;
}

export const reducers: ActionReducerMap<ContractState> = {
  details: fromContract.reducer
};

export const getContractState = createFeatureSelector<ContractState>('Contract');

export * from './contract.reducer';
